<div class="row align-items-end">
  <div class="col-md">
    <kendo-label *ngIf="seaPortPickerTitle"
                 [class]="isValid ? 'text-grey' : 'text-red'"
                 [ngClass]="{ 'required': isRequired }">
      {{ seaPortPickerTitle }}
    </kendo-label>

    <kendo-floatinglabel [ngClass]="{ 'pt-0': !!seaPortPickerTitle, 'required': isRequired }">
      <kendo-combobox
        #seaPortPicker
        [data]="seaports$()"
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        (filterChange)="onFilterChange($event)"
        [filterable]="true"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [valueField]="'id'"
        [textField]="'name'"
        [valuePrimitive]="true"
        [suggest]="false"
        [popupSettings]="{ width: 'auto' }"
        [fillMode]="'outline'"
        [class.border-red]="!isValid">

        <ng-template kendoDropDownListNoDataTemplate>
          <ng-container *ngIf="(searchText?.length || 0) > 0">
            <div class="mx-4 font-weight-light">
              <p>There is no such port in the database.</p>
            </div>
          </ng-container>
          <ng-container *ngIf="searchText?.length === 0">
            <div class="mx-4 font-weight-light">
              <p>Please, type to start searching</p>
            </div>
          </ng-container>
        </ng-template>
      </kendo-combobox>
    </kendo-floatinglabel>
  </div>
</div>
